export const loadPage = (component, {url: link}, options) => {
  const loading = new Promise(function (resolve, reject) {
    component.$f7.mainView.router.load({url: link})
    resolve(link)
  })
  loading.then(function () {
    component.$bus.emit('nextLink', link)
  })
}

export const reloadPage = (component, {url: link}, options) => {
  if (link !== '') {
    const loading = new Promise(function (resolve, reject) {
      component.$f7.mainView.allowPageChange = true
      component.$f7.mainView.router.load({url: link})
      resolve(link)
    })
    loading.then(function () {
      component.$bus.emit('nextLink', link)
    })
  }
}

/* @author TLV 24/09/2020
* @brief redirection qui recharge le component si on est actuellement dessus */
export const reloadPage2 = (component, link) => {
  const loading = new Promise(function (resolve, reject) {
    component.$f7.mainView.allowPageChange = true
    component.$f7.mainView.router.load({url: link, reload: true})
    resolve(link)
  })
  loading.then(function () {
    component.$bus.emit('nextLink', link)
  })
}

export const pageBack = (component) => {
  if (component) {
    component.$f7.views.main.router.back()
  }
}



// WEBPACK FOOTER //
// ./src/helpers/routing.js